import React, { Component } from 'react';

export default class AddIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M36.168,44.084l-25.739,0c-0.944,-0.03 -1.228,-0.152 -1.735,-0.396c-2.315,-1.115 -3.132,-4.324 -1.047,-6.477c0.063,-0.058 0.126,-0.115 0.189,-0.173c0.732,-0.583 1.262,-0.911 2.593,-0.954l25.739,0l0,-25.738c0.035,-1.113 0.481,-2.158 1.31,-2.961c1.519,-1.293 2.005,-1.063 2.818,-1.037c2.081,0.067 3.794,1.576 3.872,3.998l0,25.738l25.738,0c3.956,0.127 5.691,7.818 0,8l-25.738,0l0,25.738c-0.07,2.167 -0.638,2.35 -1.311,2.962c-2.185,1.984 -6.475,0.515 -6.681,-2.705c-0.006,-0.086 -0.006,-0.171 -0.008,-0.257l0,-25.738Z"/>
              </g>
            </svg>
        )
    }
}
